import { format, utcToZonedTime } from 'date-fns-tz';
import { ptBR } from 'date-fns/locale';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { useAuth } from 'context/AuthContext';

import Avatar, { genConfig } from 'funifier-nice-avatar';

import Tippy from '@tippyjs/react';
import { ComportamentoHelpModal } from 'components/comportamento-help-modal';
import { Countdown } from 'components/countdown';
import { Colaboracao, FocoNoCliente, Inovacao, Lideranca, MandouBem, Resolutividade, Uau, Valeu } from 'components/icons';
import { SeloMoedasModal } from 'components/moeda-help-modal';
import { PontosHelpModal } from 'components/pontos-help-modal';
import { SeloHelpModal } from 'components/selo-help-modal';
import Button from 'components/ui/button';
import { useModal } from 'context/ModalContext';
import { NotAllowed } from 'pages/NotAllowed';
import { BiInfoCircle, BiMenu, BiPlus, BiGift } from 'react-icons/bi';
import { IoIosWarning } from 'react-icons/io';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import {
  checkTeamsRecognition,
  getGroup,
  getKPIPointsOnline,
  getPartialTask,
  getPartialRecognition,
  getSelos,
  getTasksManagerQtd,
} from 'services/dashboard.service';
import { GroupDetailInterface, RankingKPI, UserGroupInterface, UsersNeedingApproval_Interface } from 'types/user';
import { TaskCycles } from './components/task-cycles';
import { TaskCycles as TaskCyclesClosed } from '../v3/Dashboard/components/task-cycles';
import { shouldShowPrefixAchievementsLink, shouldShowTaskCyclesSection } from './taskCyclesVisibility';
import './styles.scss';

import { useMsal } from '@azure/msal-react';
import Chapeu from 'assets/img/festa-junina/chapeu.gif';
import Bandeira from 'assets/img/festa-junina/bandeiras.gif';
import Balao from 'assets/img/festa-junina/balao.gif';
import Fogueira from 'assets/img/festa-junina/fogueira.gif';

// import Pascoa from 'assets/img/JJ_pascoa.png';
import Humanograma from 'components/Humanograma';
import Decoration from 'components/decoration';
// import { GameModal } from 'components/game-modal';
import { GroupDetailModal } from 'components/group-detail-modal';
import NewFeatures from 'components/new-features';
import Notification from 'components/notification';
import { PointItem } from 'components/point-item';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import ArticlePlaceholderSmall from 'components/ui/article-placeholder-small';
import { UserAvatar } from 'components/user-avatar';
import UserTutorial from 'components/user-tutorial';
import { MIN_BALANCE_TO_RECOGNIZE } from 'pages/Reconhecer/recognition-points';
import { useWebsocketNotification } from 'context/WebsocketNotificationContext';
import { MdContentPasteSearch } from 'react-icons/md';
import { getReconhecimentos } from 'services/achievement.service';
import { getBadges } from 'services/badges.service';
import { getBadgesUser, getChallenges } from 'services/challenges.service';
import { getLevelPlayer } from 'services/levels.service';
import { checkNotifications, clearNotifications, getAllNotifications } from 'services/notifications.service';
import { getPublicProfile, getUsersNeedingApproval } from 'services/profile.service';
import { getRegulation } from 'services/regulation.service';
import {
  getLevelBarStyle,
  getLevelDescription,
  getLevelStyle,
  getLevelTitle,
  getNamedDates,
  GetVersion,
  levels,
  levelType,
} from 'services/utils';
import { UserInfo } from 'types/user';
import { VERSION } from 'utils/constants';
import { Company } from './components/company';
import { NotificationsRow } from './components/notifications-row';
import Quiz from 'components/quiz';
import imgBanner from 'assets/img/banner_sosfuncibb.jpg';
import { TaskCyclesEcoa } from './components/task-cycles-ecoa';
import CustomSelect from 'components/custom-select';
import { PontosRealizacoesHelpModal } from 'components/pontos-realizacoes-help-modal';
import { GroupDetailModalExtrato } from 'components/group-detail-modal-extrato';
import OvoPascoaInterativo from 'components/pascoa';
// import FeedbackPascoaModal from 'components/pascoa-avaliacao';
import { TaskOtherIndication } from 'components/task-other-indication';
import SurpriseBox from 'components/surprise-box';
import CorreioElegante from 'components/correio-elegante';
import UserTutorialJunino from 'components/user-tutorial-junino';
import ProgressBar from 'components/ui/progress-bar';
import { FaEnvelope, FaRegClock } from 'react-icons/fa';
import { getDeadLineExperienceCatalog, VerifyExperienceCatalogItens } from 'services/experienceCataolog.service';
import { isGrupoValido } from 'utils/helpers';
import { canAccessExperienceCatalog } from 'utils/experience-catalog';
import ChristmasDecorations from 'components/christmas-decorations';
import { ChristmasGiftModal } from 'components/christmas-gift-modal';
import { ChristmasSantaSlide } from 'components/christmas-santa-slide';
import { ChristmasTreeModal } from 'components/christmas-tree-modal';
import ChristmasFallingParticles from 'components/christmas-falling-particles';
import gorro from 'assets/lottie/gorro_natal_azul.json';
import Logo from 'components/logo';
import Lottie from 'lottie-react';

import QuizV2 from 'components/quiz-v2';
import { verifyCampaign } from 'services/actionlog.service';
import PartialTask from 'components/partial-task';
import PartialRecognition from 'components/partial-recognition';
import CatalogRestockModal from './components/catalog-restock-modal';
import { NewYearEnvelopeModal } from 'components/new-year-envelope-modal';
import TeamsEvaluationModal from 'components/modal-avaliacao-teams';
import { canRenounceDynamics } from 'pages/Preference/communication-preferences';

// import { UserNeedingApprovalModal } from 'components/user-needing-approval-modal';
// import Decoration from 'components/decoration';
// import { GroupDetailModal } from 'components/group-detail-modal';
// import { PesquisaModal } from 'components/pesquisa-modal';
// import TutorialChallenges from 'components/tutorial-challenges';
// import Header from 'components/header';
// import { Tutorial } from 'components/tutorial';

const defautConfig = genConfig();

const dummyRankingKPI = { position: 0, total_positions: 0 };
const dummyKPI: any = {
  position: '---',
  uau: '---',
  mandou: '---',
  valeu: '---',
};

export function Dashboard() {
  const {
    user,
    userInfo,
    refreshUser,
    signOut,
    currentCycle,
    isMSTeams,
    realCycle,
    cycleSelected,
    setCycleSelected,
    loadingInfo,
  } = useAuth();
  const { setMessage } = useWebsocketNotification();
  const [avatarConfig, setAvatarConfig] = useState(defautConfig);
  const [isGestor, setIsGestor] = useState(false);
  const [hasTeam, setHasTeam] = useState(false);
  const [showCatalog, setShowCatalog] = useState(false);
  const [groupInfo, setGroupInfo] = useState<any>();
  const [profile, setProfile] = useState<any>();
  const [lastUpdate, setLastUpdate] = useState<any>();
  const [usersNeedingApproval, setUsersNeedingApproval] = useState<UsersNeedingApproval_Interface[]>();
  const [rulesUrl, setRulesUrl] = useState<string>();
  const [showQuiz, setShowQuiz] = useState(false);
  const [tasksManager, setTasksManager] = useState<any>();
  const [tasksDuplaManager, setTasksDuplaManager] = useState<any>();
  const [showFeedbackEasterModal, setShowFeedbackEasterModal] = useState(true);
  const [showCorreioModal, setShowCorreioModal] = useState(false);
  const [finishedTutorial, setFinishedTutorial] = useState(false);
  const [deadLineExperienceCatalog, setDeadLineExperienceCatalog] = useState<Date>(new Date());

  const [hasPartialTask, setHasPartialTask] = useState<boolean>();
  const [hasPartialRecognition, setHasPartialRecognition] = useState<boolean>();
  const [hasTeamsRecognition, setHasTeamsRecognition] = useState<boolean>();

  // Sinais da fila de modais (./modal-queue.ts): a notificacao do catalogo so abre
  // depois que toda automatica conhecida apareceu ou decidiu nao aparecer (R10).
  const [partialTaskClosed, setPartialTaskClosed] = useState(false);
  const [partialRecognitionClosed, setPartialRecognitionClosed] = useState(false);
  const [taskOtherIndicationSettled, setTaskOtherIndicationSettled] = useState(false);
  // Fixo na visita: a TeamsEvaluationModal decidiu nao aparecer (pesquisa ja respondida ou
  // falha). Separado de hasTeamsRecognition porque o loader dele reroda a cada refreshUser
  // (WebSocket) e o regravaria para true — remontando a modal e fazendo a fila piscar.
  const [teamsRecognitionSkipped, setTeamsRecognitionSkipped] = useState(false);

  // Estados para campanha de Natal
  const [showClaimButton, setShowClaimButton] = useState(false);
  const [showAutoTreeModal, setShowAutoTreeModal] = useState(false);
  const [showSantaSlide, setShowSantaSlide] = useState(false);
  const doublePointsMessage = 'Vocês pediram e o BB atendeu! Em DEZEMBRO, pontos para reconhecimentos em dobro!';
  const [isPointClaimed, setIsPointClaimed] = useState(true);

  const [showNewYearModal, setShowNewYearModal] = useState(true);
  const [showFeedbackCampaignModal, setShowFeedbackCampaignModal] = useState(false);
  const hasAutoOpenedCarnivalRef = useRef(false);

  const [load, setLoad] = useState(true);
  const { instance } = useMsal();

  const [selosBB, setSelosBB] = useState<any>();

  // const [tasks, setTasks] = useState<any>();
  // const [taskCycles, setTaskCycles] = useState<any>();
  // const [loadingTasks, setLoadingTasks] = useState(true);

  const [showTutorial, setShowTutorial] = useState(false);
  const [openTutorial, setOpenTutorial] = useState(false);
  const [closeFeatures, setCloseFeatures] = useState(false);

  const [sealList, setSealList] = useState<any[]>();
  const [loadingCulturaList, setLoadingCulturaList] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();
  const { showModal, openModal } = useModal();

  const [destaqueCultura, setDestaqueCultura] = useState({
    foco: dummyKPI,
    colaboracao: dummyKPI,
    inovacao: dummyKPI,
    resolutividade: dummyKPI,
    lideranca: dummyKPI,
  });

  const [pontosCultura, setPontosCultura] = useState<{
    time: number;
    foco: number;
    colaboracao: number;
    inovacao: number;
    resolutividade: number;
    lideranca: number;
    total: number;
    geral: number;
    tasks: number;
    joga_junto: number;
    ranking_galeria: any;
  }>({
    time: 0,
    foco: 0,
    colaboracao: 0,
    inovacao: 0,
    resolutividade: 0,
    lideranca: 0,
    total: 0,
    geral: 0,
    tasks: 0,
    joga_junto: 0,
    ranking_galeria: undefined,
  });

  const [galeriaReconhecimento, setGaleriaReconhecimento] = useState<RankingKPI>(dummyRankingKPI);

  const optionsSelectCycle = useMemo(
    () =>
      realCycle?.map(x => {
        return {
          _id: x._id,
          title: x.title,
          version: GetVersion(x.date_start),
        };
      }),
    [realCycle],
  );

  const verifyVersionInit = useCallback(() => {
    if (cycleSelected && cycleSelected?.version) {
      navigate(`/${cycleSelected.version}/`);
    }
  }, [cycleSelected, navigate]);

  function handleNavMobile() {
    document.dispatchEvent(new CustomEvent('openNavMobile'));
  }

  function messageLevel() {
    return (
      <div>
        <p>A sua colocação é calculada sobre a quantidade total de pessoas do seu grupo.</p>
        <br />
        <p>
          Estarão na lista final da “Galeria do Reconhecimento”, somente os 30% melhores colocados do seu grupo (com
          arredondamento para cima).
        </p>
        <br />
        <p>A divulgação dos ganhadores será realizada em ordem alfabética. Apenas você poderá ver a sua colocação.</p>
      </div>
    );
  }

  const handleAvatarClick = useCallback(() => {
    showModal('avatar', { config: avatarConfig });
  }, [avatarConfig, showModal]);

  // const handlePascoaClick = () => {
  //   showModal('game-modal');
  // };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const result = await verifyGame('game_pascoa');

  //     if(!result) {
  //       showModal('game-modal');
  //     }
  //   };
  //   fetchData();
  // }, []);

  // function getTaskPoints(task: any) {
  //   const myPoints = task.team.find((item: any) => item._id === user?._id);
  //   return myPoints.points || 0;
  // }

  function getPositionLabel(kpi: RankingKPI) {
    try {
      return (
        <div className="p-1 text-center">
          <p>
            Você está na colocação <b>{kpi.position}</b> de <b>{groupInfo.total}</b> dentro do seu grupo.{' '}
            {!!lastUpdate
              ? `Ranking atualizado em: ${format(new Date(lastUpdate), 'd MMM yyyy, HH:mm', {
                  locale: ptBR,
                })}.`
              : ''}
          </p>
          <p>
            Estarão na lista final desta mecânica "Galeria do Reconhecimento", somente os 30% melhores colocados, com
            arredondamento para cima.
          </p>

          <p>A divulgação dos ganhadores será realizada por ordem alfabética.</p>
          <p>A sua posição nesta mecânica está visível somente a você.</p>
        </div>
      );
    } catch (e) {
      return `---`;
    }
  }

  function getPositionCulturaLabel(kpi: any) {
    try {
      return (
        <div className="p-1 text-center">
          <p>
            Você está na colocação <b>{kpi.posicao}</b> de <b>{groupInfo.total}</b> dentro do seu grupo.{' '}
            {!!lastUpdate
              ? `Ranking atualizado em: ${format(new Date(lastUpdate), 'd MMM yyyy, HH:mm', {
                  locale: ptBR,
                })}.`
              : ''}
          </p>

          <p>
            Estarão na lista final desta mecânica "Destaques da Cultura" 5% dos participantes dentro do seu grupo, com
            arredondamento para cima, que receberem mais pontos em cada Comportamento da Cultura.
          </p>

          <p>A divulgação dos ganhadores será realizada por ordem alfabética.</p>
          <p>A sua posição nesta mecânica está visível somente a você.</p>
        </div>
      );
    } catch (e) {
      return `---`;
    }
  }

  function getMoedas(data: any, moeda: string) {
    try {
      return data[moeda];
    } catch (e) {
      return '---';
    }
  }

  function getPontosPorCultura(data: any[], behavior: string) {
    const dummy = {
      posicao: '---',
      uau: '---',
      mandou: '---',
      valeu: '---',
    };
    const pontos = data.find((item: any) => item.behavior === behavior);
    if (!pontos) {
      return dummy;
    }
    return pontos;
  }

  useEffect(() => {
    try {
      const locationState: any = location.state;
      if (locationState && locationState.direction) {
        if (locationState.direction === 'back') {
          refreshUser();
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [location, refreshUser]);

  useEffect(() => {
    async function loadKPIComportamento() {
      try {
        const resultPointsOnline = await getKPIPointsOnline(user?._id, null, cycleSelected?._id);

        const _pontosCultura: any = {
          time: resultPointsOnline.time,
          foco: 0,
          colaboracao: 0,
          inovacao: 0,
          resolutividade: 0,
          lideranca: 0,
          total: resultPointsOnline.total || 0,
          geral: resultPointsOnline.geral || 0,
          tasks: resultPointsOnline.tasks || 0,
          joga_junto: resultPointsOnline.joga_junto || 0,
          ranking_galeria: !!resultPointsOnline.ranking_galeria ? resultPointsOnline.ranking_galeria : undefined,
        };

        resultPointsOnline.positions?.forEach((position: any) => {
          _pontosCultura[position.behavior] = position.total;
        });
        // console.log(_pontosCultura);
        setPontosCultura(_pontosCultura);

        // const kpiPontosCultura = await getKPIPontosCultura(user?._id);
        // setGaleriaReconhecimento({
        //   position: !!resultPointsOnline?.ranking_galeria?.position ? resultPointsOnline?.ranking_galeria?.position : 0,
        //   total: !!resultPointsOnline.geral ? resultPointsOnline.geral : 0,
        // });
        // setLastUpdate(kpiPontosCultura?.time || undefined);

        // if (!!kpiPontosCultura?.positions?.length) {
        //   const _destaqueCultura: any = {
        //     foco: { posicao: '---' },
        //     colaboracao: { posicao: '---' },
        //     inovacao: { posicao: '---' },
        //     resolutividade: { posicao: '---' },
        //     lideranca: { posicao: '---' },
        //   };

        //   kpiPontosCultura.positions.forEach((position: any) => {
        //     _destaqueCultura[position.behavior].posicao = position.position;
        //   });

        //   setDestaqueCultura(_destaqueCultura);
        // }
      } catch (e) {
        console.log(e);
      }
    }

    if (user?._id && cycleSelected?._id) {
      loadKPIComportamento();
    }
  }, [user?._id, cycleSelected?._id]);

  useEffect(() => {
    function updateAvatar() {
      if (user?.extra.avatar) {
        setAvatarConfig(user?.extra.avatar);
      }
    }

    function shouldShowTutorial() {
      if (!user?.extra.tutorial || !localStorage.getItem('tutorial')) {
        setShowTutorial(true);
      }
    }

    async function loadlLevel() {
      try {
        if (!userInfo?.chave || !cycleSelected?._id) return;
        const data = await getLevelPlayer();
        const userProfile = await getPublicProfile(userInfo?.chave, cycleSelected?._id);

        const item = {
          ...data,
          nivel: userProfile?.level ? userProfile?.level : data?.nivel,
          level: userProfile?.level ? userProfile?.level : data?.nivel,
          grupo: userProfile?.grupo ? userProfile?.grupo : userInfo?.grupo?.nome,
          grupoTotal: userProfile?.grupo_total ? userProfile?.grupo_total : userInfo?.grupo?.total,
        };

        setProfile(item);
      } catch (e) {}
    }

    async function loadCulturalList() {
      if (!!user && !!user?._id) {
        let list = [];
        setLoadingCulturaList(true);
        const galeriaList = await getSelos();
        // const galeriaList = await getGaleriaSecondByUser(user?._id);
        // const culturalList = await getResultadosByUser(user?._id);

        list = [...galeriaList];

        setSealList(list);

        setLoadingCulturaList(false);
      }
    }

    if (!user || !cycleSelected?._id) return;

    loadCulturalList();
    loadlLevel();
    updateAvatar();
    shouldShowTutorial();

    const returnURL = sessionStorage.getItem('return');

    if (returnURL) {
      sessionStorage.removeItem('return');
      navigate(returnURL);
    }
  }, [user, navigate, showModal, userInfo, cycleSelected]);

  useEffect(() => {
    async function loadTeam() {
      let catalog = await getGroup(cycleSelected?.title);

      if (!catalog) {
        catalog = {};
        catalog.grupo = userInfo?.grupo?.nome;
      }

      setHasTeam(
        !!userInfo &&
          !!userInfo.is_manager &&
          (!!userInfo.team || (Array.isArray(userInfo?.mad_dupla) && userInfo?.mad_dupla?.some((md: any) => md.team === true))),
      );

      setShowCatalog(!!catalog?.grupo && isGrupoValido(catalog.grupo) ? true : false);

      const regulation = await getRegulation();
      setRulesUrl(regulation?.url);

      setLoad(false);
    }

    async function loadTasks() {
      const taskCycleResults = realCycle?.find(e => e._id === cycleSelected?._id);

      const duplaId = Array.isArray(userInfo?.mad_dupla) && userInfo?.mad_dupla?.length ? userInfo.mad_dupla[0]._id : undefined;

      // As duas consultas são independentes entre si — encadeadas por `await` o gestor MAD
      // pagava as duas em série (~130ms cada no `tasks_manager_qtd`, dominado pelo
      // `$function` JS). Em paralelo o resultado é idêntico, muda só o tempo de parede.
      const [data, dataDupla] = await Promise.all([
        getTasksManagerQtd(user?.extra.id, taskCycleResults?.date_start, taskCycleResults?.date_end),
        duplaId ? getTasksManagerQtd(duplaId, taskCycleResults?.date_start, taskCycleResults?.date_end) : undefined,
      ]);

      if (duplaId) {
        setTasksDuplaManager(dataDupla);
      }

      setTasksManager(data);
    }

    if (!!userInfo && !!user && !!currentCycle) {
      setIsGestor(userInfo?.is_manager);
      if (userInfo.grupo) {
        setGroupInfo({
          ro: userInfo.ro,
          grupo_definido: userInfo.grupo_definido,
          ...userInfo.grupo,
        });
      }

      loadTeam();
      if (userInfo?.is_manager && realCycle && realCycle?.length > 0) {
        loadTasks();
      } else {
        setTasksManager([]);
      }
    }
  }, [user, currentCycle, userInfo, cycleSelected, realCycle]);

  function handleLogout() {
    instance.logoutRedirect({
      onRedirectNavigate: () => false,
    });
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const updateAvatar = searchParams.get('avatar');
    const openQuiz = searchParams.get('quiz');
    const openTutorial = searchParams.get('tutorial');

    if (updateAvatar) {
      setTimeout(() => {
        handleAvatarClick();
      }, 1e2);

      searchParams.delete('avatar');
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }

    if (openQuiz) {
      setShowQuiz(true);

      searchParams.delete('quiz');
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }

    if (openTutorial) {
      setShowTutorial(true);
      setOpenTutorial(true);

      searchParams.delete('tutorial');
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (Array.isArray(usersNeedingApproval) && usersNeedingApproval.filter(x => !x.notificationBeenRead).length) {
      showModal('user-needing-approval-modal');
    }
  }, [showModal, usersNeedingApproval]);

  useEffect(() => {
    verifyVersionInit();
  }, [verifyVersionInit]);

  useEffect(() => {
    const fetchDeadLine = async () => {
      if (!canAccessExperienceCatalog(userInfo) || !currentCycle?._id) {
        return;
      }
      const deadLineResponse = await getDeadLineExperienceCatalog(currentCycle?._id);

      let endDate;
      if (deadLineResponse?.endDate?.$date) {
        endDate = new Date(deadLineResponse?.endDate.$date);
      } else if (typeof deadLineResponse?.endDate === 'string') {
        endDate = new Date(deadLineResponse?.endDate);
      } else if (deadLineResponse?.endDate instanceof Date) {
        endDate = deadLineResponse?.endDate;
      } else {
        console.error('Invalid endDate format:', deadLineResponse?.endDate);
        endDate = new Date();
      }
      setDeadLineExperienceCatalog(endDate);
    };

    if (!!userInfo && !!currentCycle?._id) {
      fetchDeadLine();
    }
  }, [userInfo, currentCycle]);

  useEffect(() => {
    if (!userInfo || !user || !currentCycle) return;

    async function loadPartialTask() {
      try {
        const partialTask = await getPartialTask();
        setHasPartialTask(!!partialTask?.team);
      } catch (error) {
        console.error('Erro ao carregar task parcial:', error);
      }
    }

    loadPartialTask();

    document.addEventListener('reload:partialTask', loadPartialTask, false);

    return () => {
      document.removeEventListener('reload:partialTask', loadPartialTask);
    };
  }, [user, userInfo, currentCycle]);

  useEffect(() => {
    if (!userInfo || !user || !currentCycle) return;

    async function loadPartialRecognition() {
      try {
        const partialRecognition = await getPartialRecognition();
        setHasPartialRecognition(
          !!partialRecognition?.target ||
            !!partialRecognition?.behavior ||
            !!partialRecognition?.coin ||
            !!partialRecognition?.message,
        );
      } catch (error) {
        console.error('Erro ao carregar reconhecimento parcial:', error);
      }
    }

    loadPartialRecognition();

    document.addEventListener('reload:partialRecognition', loadPartialRecognition, false);

    return () => {
      document.removeEventListener('reload:partialRecognition', loadPartialRecognition);
    };
  }, [user, userInfo, currentCycle]);

  useEffect(() => {
    if (!userInfo || !user || !currentCycle) return;

    async function loadTeamsRecognitionCheck() {
      try {
        const hasTeams = await checkTeamsRecognition();
        setHasTeamsRecognition(hasTeams);
      } catch (error) {
        console.error('Erro ao verificar reconhecimento no Teams:', error);
      }
    }

    loadTeamsRecognitionCheck();
  }, [user, userInfo, currentCycle]);

  const cycleIsOpen = useMemo(
    () => realCycle?.find(e => e._id === cycleSelected?._id)?.status === 'open',
    [realCycle, cycleSelected],
  );

  const cycleIsClosed = useMemo(
    () => realCycle?.find(e => e._id === cycleSelected?._id)?.status === 'closed',
    [realCycle, cycleSelected],
  );

  /**
   * Os três campos que `canRenounceDynamics` lê, no formato que ela espera — o
   * mesmo mapeamento que a página de preferências faz (`Preference/index.tsx`).
   */
  const preferenceEligibility = useMemo(
    () => ({
      isManager: !!userInfo?.is_manager,
      cadMissao: userInfo?.cad_missao,
      tipoRo: userInfo?.tipo_ro,
    }),
    [userInfo],
  );

  const selectCycle = useMemo(() => realCycle?.find(e => e._id === cycleSelected?._id), [realCycle, cycleSelected]);

  function showCardNewYear() {
    showModal && showModal('new-year-envelope-direct');
  }

  if (!user) return null;

  if (!user.extra.id) {
    return <NotAllowed />;
  }

  const taskCyclesEligibility = {
    loadingInfo,
    isRede: !!user.extra.rede,
    userInfo,
    tasksManager,
    tasksDuplaManager,
  };

  // Governa a seção TaskCycles da home. Some com o ciclo fechado, porque nesse caso a home
  // troca a seção por `TaskCyclesClosed`.
  const showTaskCycles = shouldShowTaskCyclesSection({ ...taskCyclesEligibility, cycleIsClosed });

  // Governa o item de menu "Realizações do seu prefixo". Mesma elegibilidade, mas sobrevive
  // ao ciclo fechado: a listagem é histórica e tem seletor de ciclo próprio.
  const showPrefixAchievementsLink = shouldShowPrefixAchievementsLink(taskCyclesEligibility);

  return (
    <>
      <style>{`
        @keyframes partialRecognitionPulse {
          0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(251, 253, 0, 0.4); }
          50% { transform: scale(1.1); box-shadow: 0 0 0 10px rgba(251, 253, 0, 0); }
          100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(251, 253, 0, 0); }
        }
      `}</style>
      {/* <PesquisaModal /> */}
      <Outlet />

      <div className="flex flex-col md:pt-10 pb-20 lg:pb-0 lg:flex-row mx-auto xl:container">
        <div className="p-6 lg:p-3 lg:w-1/3 flex flex-col items-center">
          {/* <div className="w-full flex flex-row lg:flex-col lg:items-center justify-between my-2 lg:my-4 relative" tabIndex={1}>
            <div className="lg:hidden" onClick={() => handleNavMobile()}>
              <BiMenu size={32} />
            </div>
          </div> */}

          <div className="w-full flex flex-row lg:flex-col lg:items-center justify-between my-2 lg:my-4 relative" tabIndex={1}>
            <div className="w-20 lg:w-72">
              <Logo />
            </div>

            <div className="lg:hidden" onClick={() => handleNavMobile()}>
              <BiMenu size={32} />
            </div>
          </div>

          <div className="mt-8 lg:mt-5 text-left lg:text-center w-full">
            <h1 className="text-3xl text-white font-semibold" tabIndex={2} aria-label="Slogan: Juntos fazemos muito mais">
              Juntos fazemos <br />
              muito mais!
            </h1>

            <div
              className="relative border border-white w-[190px] mx-auto mt-5 pb-1 text-center uppercase"
              tabIndex={3}
              aria-label="Logo: Uma vida de oportunidades "
            >
              <span className="absolute -top-[8px] left-1/2 transform -translate-x-1/2 bg-[#032B4D] w-[110px] leading-none">
                Uma <b>vida</b> de
              </span>
              <p className="text-yellow leading-none text-xl mt-2">oportunidades</p>
            </div>
          </div>

          {Array.isArray(optionsSelectCycle) && !!optionsSelectCycle.length && (
            <div className="w-full lg:w-[206px] mt-10">
              <CustomSelect
                disabled={loadingInfo}
                value={{
                  label: cycleSelected?.title,
                  value: cycleSelected?._id,
                }}
                placeholder="Clique para selecionar o ciclo"
                options={optionsSelectCycle.map((item: any) => {
                  return {
                    label: item.title,
                    value: item._id,
                  };
                })}
                onChange={(e: any) => {
                  const selected = optionsSelectCycle.find(x => x._id === e.value);
                  setCycleSelected(selected);

                  if (selected?.version) {
                    navigate(`/${selected.version}/`);
                  } else {
                    navigate('/');
                  }
                }}
              />
            </div>
          )}

          {load && (
            <div className="space-y-3 w-full hidden lg:flex flex-col items-center mt-10">
              <ArticlePlaceholderSmall />
              <ArticlePlaceholderSmall />
              <ArticlePlaceholderSmall />
              <ArticlePlaceholderSmall />
              <ArticlePlaceholderSmall />
              <ArticlePlaceholderSmall />
              <ArticlePlaceholderSmall />
            </div>
          )}

          {!load && (
            <div data-step="6" className="hidden lg:flex flex-col space-y-5 mt-10">
              {/* {user?.extra?.rede && (
                <button
                  onClick={() => setShowQuiz(true)}
                  className="text-2xl font-normal leading-none hover:text-yellow focus:text-yellow active:text-yellow text-yellow flex items-center justify-center space-x-2 mb-3"
                >
                  <MdContentPasteSearch className="text-[2.5rem]" />{' '}
                  <span className="text-2xl font-normal leading-none">
                    Quiz Regras <br /> do Programa
                  </span>
                </button>
              )} */}

              {/* <a
                href="https://forms.office.com.mcas.ms/pages/responsepage.aspx?id=BykM6tI4gUGHULCxkLYEQ86IL6aO8Y9IoaMZHcLVA5dUQlVaVUY4SFNIUUdaMU1HQ08yWUxWRkRFUS4u"
                target="_blank"
                rel="noreferrer"
                className="text-2xl font-normal leading-none hover:text-yellow focus:text-yellow active:text-yellow text-yellow flex items-center justify-center space-x-2 mb-3"
              >
                <MdContentPasteSearch className="text-[2.5rem]" />
                <span className="text-2xl font-normal leading-none">
                  Avalie o #JogaJuntoBB
                </span>
              </a> */}

              <Link
                to="/destaques"
                aria-label="Destaques do Joga junto"
                className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline shadow-xl font-bold px-4"
                children={<span className="p-2 w-full uppercase">DESTAQUES</span>}
              />

              {showCatalog && (
                <Link
                  to={`${user?.extra?.rede ? '/loja' : '/catalogo-de-experiencias'}`}
                  aria-label="Catálogo de experiências Livelo"
                  className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                  children={
                    <span className="p-2 w-full uppercase ">
                      {selectCycle && selectCycle?.date_end > getNamedDates().ciclo_1S2025
                        ? 'EXTRATO DE PREMIAÇÃO'
                        : 'PONTOS LIVELO'}
                    </span>
                  }
                />
              )}

              {canAccessExperienceCatalog(userInfo) && (
                <Link
                  to={`catalogo-de-experiencias-list`}
                  aria-label="Catálogo de experiências Livelo"
                  className="bg-electric-blue text-blue-dark p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                  children={
                    <span className="p-2 w-full uppercase relative">
                      catálogo de experiências
                      {/* <Tippy
                        content={
                          deadLineExperienceCatalog.getTime() > Date.now() ? (
                            <span>
                              Tempo restante: <Countdown deadline={deadLineExperienceCatalog} />
                            </span>
                          ) : (
                            <span>Periodo de troca esgotado</span>
                          )
                        }
                        arrow={true}
                        placement="top"
                      >
                        <span className="absolute -right-6 -top-2 bg-red-500 rounded-full p-1 shadow-md cursor-pointer">
                          <FaRegClock className="text-white w-5 h-5" />
                        </span>
                      </Tippy> */}
                    </span>
                  }
                />
              )}

              {/* <Link */}
              {/* <Link
                to="/destaques-cultura"
                children={
                  <Button
                    color="primary"
                    className="p-2 w-full uppercase rounded-md"
                  >
                    DESTAQUES DA CULTURA BB
                          <Button
                            id="double-points-button"
                }
              /> */}

              {/* <Link
              to="/destaques-cultura"
              children={
                <Button color="primary" className="p-2 w-full uppercase rounded-md">
                  Destaques da Cultura BB
                        <Button
                          id="double-points-button"
              }
            /> */}

              {/* <Link
                to="/extrato"
                children={
                  <Button
                    color="primary"
                    className="p-2 w-full uppercase rounded-md"
                  >
                    Extrato de pontos
                  </Button>
                }
              /> */}

              {!!userInfo?.is_manager && !user?.extra.rede && (
                <Link
                  to="/minha-equipe"
                  aria-label="Pendências de aprovação"
                  className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                  children={
                    <span className="p-2 w-full uppercase rounded-md relative">
                      Minha Equipe{' '}
                      {!!usersNeedingApproval?.length && (
                        <span className="number-indicator" title="Pendências de aprovação">
                          {usersNeedingApproval?.length}
                        </span>
                      )}
                    </span>
                  }
                />
              )}

              <Link
                to="/rede-joga-junto"
                aria-label="Rede JogaJunto"
                className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                children={<span className="p-2 w-full uppercase rounded-md">Rede JogaJunto</span>}
              />

              {showPrefixAchievementsLink && (
                <Link
                  to="/realizacoes-do-prefixo"
                  aria-label="Realizações Destaque"
                  className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                  children={<span className="p-2 w-full uppercase rounded-md">Realizações Destaque</span>}
                />
              )}

              {/* {isGestor ? (
              <Link
                to="/minha-equipe/validar-apreciar-realizacao"
                children={
                  <Button
                    color="primary"
                    className="p-2 w-full uppercase rounded-md"
                  >
                    Realização Destaque
                  </Button>
                }
              />
            ) : null}
            {!isGestor ? (
              <Link
                to="/realizacao-destaque"
                children={
                  <Button
                    color="primary"
                    className="p-2 w-full uppercase rounded-md"
                  >
                    Realização Destaque
                  </Button>
                }
              />
            ) : null} */}
              {/*
            <Link
              to="/reconhecer"
              children={
                <Button
                  color="primary"
                  className="p-2 w-full uppercase rounded-md"
                >
                  Emitir Moedas BB
                </Button>
              }
            /> */}

              {/* <Link
              to="/experiencias"
              children={
                <Button color="primary" className="p-2 w-full uppercase rounded-md">
                  Catálogo de experiências
                </Button>
              }
            /> */}

              {user.extra.rede ? (
                <Link
                  to="/regulamento"
                  children={
                    <Button color="primary" className="p-2 w-full uppercase rounded-md">
                      Regras
                    </Button>
                  }
                />
              ) : (
                <a
                  href={rulesUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                  aria-label="Regras do JogaJunto"
                >
                  <span className="p-2 w-full uppercase rounded-md" aria-hidden="true">
                    Regras
                  </span>
                </a>
              )}

              {/* <Link
                to="/regulamento"
                children={
                  <Button color="primary" className="p-2 w-full uppercase rounded-md">
                    Regras
                  </Button>
                }
              /> */}

              {/* <a
                href="https://banco365.sharepoint.com/sites/NovoJogaJuntoBB"
                target="_blank"
                rel="noreferrer"
                className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                aria-label="Ir para Hotsite do JogaJunto"
              >
                <span className="p-2 w-full uppercase rounded-md" aria-hidden="true">
                  Hotsite JogaJunto BB
                </span>
              </a> */}

              <Link
                to="/ajuda"
                aria-label="Dúvidas frequentes sobre o JogaJunto"
                className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                children={
                  <span className="p-2 w-full uppercase rounded-md" aria-hidden="true">
                    dúvidas frequentes
                  </span>
                }
              />

              {/*
                MINHA PREFERENCIAS

                Quem entra é quem renuncia a dinâmica — a mesma regra de sempre, e por
                decisão do usuário em 2026-08-07 (PREF-01.4). Entre 05/08 e 07/08 o link
                ficou aberto a todos com ciclo aberto, para dar ao gestor caminho até o
                opt-out de canal; a decisão foi desfazer isso por inteiro, e não só para
                o gestor. São 4.127 dos 22.947 ativos sem o link: 3.573 gestores e 554
                que não são gestores mas têm `cad_missao = 0` ou `tipo_ro = GERENCIAL`.

                Eles NÃO ficam sem preferência: o modal de aceite do ciclo mostra os
                blocos de canal para todos (PREF-04.2) e só esconde o bloco de renúncia
                (PREF-04.3). Quem não vê este link escolhe no início do ciclo e não
                revisita — a rota `/minhas-preferencias` segue sem bloqueio para quem
                chegar por URL.

                A condição é `canRenounceDynamics` e não os três campos reescritos aqui:
                é literalmente a mesma expressão, já tem teste próprio, e duplicá-la
                deixaria dois lugares para manter em acordo — que foi como este botão se
                desencontrou da página em primeiro lugar.

                `cycleIsOpen` fica: sem ciclo aberto não há chave `matrícula_ciclo` para
                gravar, e a página abriria só para avisar que não salva (PREF-03.1).
              */}
              {cycleIsOpen && canRenounceDynamics(preferenceEligibility) && (
                <Link
                  to="/minhas-preferencias"
                  aria-label="Configurar minhas preferências de participação e comunicação"
                  className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                  children={
                    <span className="p-2 w-full uppercase rounded-md" aria-hidden="true">
                      Minhas preferências
                    </span>
                  }
                />
              )}

              <Link
                to="/manifesto"
                aria-label="Manifesto do JogaJunto"
                className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                children={
                  <span className="p-2 w-full uppercase rounded-md" aria-hidden="true">
                    Nosso Manifesto
                  </span>
                }
              />

              {!isMSTeams && (
                <Button
                  aria-label="Sair do JogaJunto"
                  onClick={() => {
                    handleLogout();
                    signOut();
                  }}
                  color="outlinePurple"
                  className="p-2 w-full uppercase rounded-md text-white"
                >
                  Sair
                </Button>
              )}

              <div data-app-version className="text-center text-xs mt-8 text-white text-opacity-90" aria-hidden={'true'}>
                {VERSION}
              </div>
            </div>
          )}
        </div>

        <div className="flex-1 p-6 lg:p-5 2xl:p-10 space-y-5">
          <div
            data-step="1"
            className={`relative border-electric-blue border-2 bg-oxford-blue rounded-2xl lg:rounded-[20px] flex flex-col lg:flex-row ${
              !sealList ? 'items-center' : ''
            }`}
          >
            <div className="flex flex-col p-8 h-full" tabIndex={0}>
              <div className="lg:flex-none flex flex-row items-center lg:-my-4 lg:p-4 lg:pr-6 space-x-4 lg:space-x-0">
                <div
                  onClick={() => handleAvatarClick()}
                  className="relative cursor-pointer hover:animate-wiggle flex flex-col items-center justify-center hover:ring-2 ring-white w-16 h-16 lg:w-20 lg:h-20 rounded-full"
                >
                  {/* <div className="z-[15] transform rotate-12 scale-x-[-1] absolute -top-[24px] -right-[40px] w-[150px] h-w-[150px]">
                    <Lottie animationData={gorro} loop autoplay style={{ width: '100%', height: '100%' }} />
                  </div> */}
                  <UserAvatar data={{ ...user, ...user.extra }} responsive={true} />
                </div>
                <div className="lg:p-3 flex flex-col leading-none">
                  <Humanograma data={{ ...userInfo, _id: userInfo?.chave }}>
                    <div className="flex items-center">
                      <h3
                        className="text-white text-xl lg:text-2xl font-semibold leading-none mr-2"
                        tabIndex={0}
                        aria-label={`${userInfo?.nome_guerra?.split(' ')[0]} Chave ${user._id}`}
                      >
                        {userInfo?.nome_guerra?.split(' ')[0]}
                      </h3>
                      <span className="text-white font-thin text-xs lg:text-lg leading-none">({user._id})</span>
                    </div>
                  </Humanograma>

                  <div className="-mt-1 mb-1">
                    <p className="text-sm font-light">
                      Função atual: <span className="text-blue-light">{userInfo?.funcao}</span>
                    </p>
                  </div>
                  <div className="-mt-1 mb-1">
                    <p className="text-sm font-light">
                      Tipo de Acordo de Trabalho Conexão: <span className="text-blue-light">{userInfo?.tipo_de_acordo}</span>
                    </p>
                  </div>

                  {/* {!user.extra.rede && !!isGrupoValido(profile?.grupo) && (
                    <>
                      <div className="flex items-center space-x-2">
                        <p className="text-lg" tabIndex={0} aria-label={`Nível ${getLevelTitle(profile?.nivel)}`}>
                          Nível: <b className="text-blue-light">{getLevelTitle(profile?.nivel)}</b>
                        </p>

                        <Tippy
                          arrow={true}
                          allowHTML={true}
                          className="bg-black text-white font-thin rounded-xl p-2 tippy"
                          content={
                            <div
                              dangerouslySetInnerHTML={{
                                __html: getLevelDescription(profile?.nivel, profile?.grupo),
                              }}
                            />
                          }
                        >
                          <div
                            tabIndex={0}
                            aria-label={`Mais informações sobre os níveis de engajamento. ${getLevelDescription(profile?.nivel)}`}
                          >
                            <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" />
                          </div>
                        </Tippy>
                      </div>
                    </>
                  )} */}

                  {/* {console.log(profile)} */}
                  {!!groupInfo && !!profile && !user?.extra?.rede && (
                    <div
                      className="cursor-pointer hidden lg:flex flex-col 2xl:flex-row flex-wrap 2xl:items-center leading-none space-x-1 text-white text-lg mt-2 cursor-pointerss"
                      onClick={() => showModal('group-detail-extrato')}
                    >
                      <div className="text-md p-1 px-4 rounded-2xl bg-maastricht-blue text-white mb-3 2xl:mb-0">
                        <button aria-label={`Seu grupo é ${profile?.grupo}`} className="bg-none border-none p-0 m-0" tabIndex={0}>
                          GRUPO: {profile?.grupo}
                        </button>
                      </div>
                      <div className="flex items-center space-x-2">
                        <span className="font-thin">({profile?.grupoTotal}</span> <span>funcis)</span>
                        <Tippy
                          arrow={true}
                          allowHTML={true}
                          className="bg-black text-white font-thin rounded-xl p-2 tippy"
                          content={<div>Essa informação poderá ser alterada até a divulgação do resultado do ciclo.</div>}
                        >
                          <div>
                            <BiInfoCircle className="block color-[#C2D2FF] text-base lg:text-2xl" />
                          </div>
                        </Tippy>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {!!groupInfo && !!profile && !user?.extra?.rede && userInfo?.tipo_de_acordo !== 'PREDEFINIDO' && (
                <>
                  <div
                    className="flex w-full lg:hidden flex-col items-center justify-between text-center leading-none space-x-2 text-white text-sm"
                    onClick={() => showModal('group-detail-extrato')}
                  >
                    <div className="text-md p-1 px-4 rounded-2xl bg-maastricht-blue text-electric-blue mb-3 2xl:mb-0">
                      GRUPO: {profile?.grupo}
                    </div>
                    <div className="font-thin flex space-x-2">
                      (<span className="font-light">{profile?.grupoTotal}</span> <span>funcis)</span>
                      <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" />
                    </div>
                  </div>

                  <hr className="border-[#072E4A] lg:border-electric-blue w-full my-6 block lg:hidden" />
                </>
              )}

              <div className="flex w-full">
                <div className="w-[110px] flex flex-col items-center justify-center pt-4">
                  {loadingCulturaList ? (
                    <div>
                      <ArticlePlaceholderSmall />
                    </div>
                  ) : (
                    <>
                      {sealList && sealList?.length > 0 ? (
                        <div className="mb-2">
                          <PointItem
                            data={{
                              typeItem: sealList[0]?.type ? true : false,
                              behavior: sealList[0]?.behavior,
                              cycle: sealList[0]?.cycle,
                              type: 'destaque_cultura_icon',
                            }}
                          />
                        </div>
                      ) : (
                        <div className="px-3">
                          <p className="text-center text-[10px] text-[#597B95] bg-[#022138] py-3">Você ainda não possui selos</p>
                        </div>
                      )}

                      <Link
                        to={'/selos'}
                        aria-label="Ir para Galeria de Selos"
                        tabIndex={0}
                        className="text-grey-dark text-[10px] px-4 py-[7px] uppercase underline hover:text-white"
                      >
                        Ver todos
                      </Link>
                    </>
                  )}
                </div>

                {!user.extra.rede && !!isGrupoValido(profile?.grupo) && (
                  <div className="w-full flex flex-col lg:block lg:border-t-2 border-[#072E4A] lg:mt-3 lg:pt-3">
                    <div className="flex items-center justify-between lg:justify-start space-x-1 mb-3">
                      <p className="text-lg" tabIndex={0} aria-label={`Nível ${getLevelTitle(profile?.nivel)}`}>
                        Nível: <b className="text-blue-light">{getLevelTitle(profile?.nivel)}</b>
                      </p>

                      <Tippy
                        arrow={true}
                        allowHTML={true}
                        className="bg-black text-white font-thin rounded-xl p-2 tippy"
                        content={
                          <div
                            dangerouslySetInnerHTML={{
                              __html: getLevelDescription(profile?.nivel, profile?.grupo),
                            }}
                          />
                        }
                      >
                        <div
                          role="img"
                          tabIndex={0}
                          aria-label={`Mais informações sobre os níveis de engajamento. ${getLevelDescription(profile?.nivel)}`}
                        >
                          <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" aria-hidden="true" />
                        </div>
                      </Tippy>
                    </div>

                    <div className="grid grid-cols-4 gap-4">
                      {loadingCulturaList ? (
                        <>
                          <ArticlePlaceholderSmall />
                          <ArticlePlaceholderSmall />
                          <ArticlePlaceholderSmall />
                          <ArticlePlaceholderSmall />
                        </>
                      ) : (
                        [
                          { level: 'joga', label: '#jogando Junto' },
                          { level: 'valeu', label: '#Valeu' },
                          { level: 'mandou', label: '#MandouBem' },
                          { level: 'uau', label: '#Uau' },
                        ].map((item: { level: string; label: string }, index: number) => (
                          <div key={item.level}>
                            <Tippy
                              arrow={true}
                              allowHTML={true}
                              className="bg-black text-white font-thin rounded-xl p-2 tippy"
                              content={
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: getLevelDescription(levels[index], item.level),
                                  }}
                                />
                              }
                            >
                              <p className={`font-thin mb-2 ${getLevelStyle(profile?.nivel, item.level)}`}>{item.label}</p>
                            </Tippy>
                            <div className={`rounded-2xl h-[10px] ${getLevelBarStyle(profile?.nivel, item.level)}`}></div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* {!!sealList && sealList?.length > 0 ? (
                <div className="flex flex-col lg:block lg:border-t-2 border-[#072E4A] lg:mt-3 lg:pt-3">
                  <h3 className="text-white font-bold text-sm mb-2">Galeria de selos</h3>
                  <div className="flex items-center">
                    {loadingCulturaList && (
                      <div className="grid grid-cols-1 lg:grid-cols-3 items-center lg:gap-8 w-fit rounded-2xl ">
                        <ArticlePlaceholderSmall />
                        <ArticlePlaceholderSmall />
                        <ArticlePlaceholderSmall />
                      </div>
                    )}

                    {sealList && sealList?.length > 0 && (
                      <>
                        <div className="flex items-center">
                          <PointItem
                            data={{
                              items: [...sealList],
                              type: 'destaque_cultura_condensed',
                            }}
                          />
                          <Link
                            to={'/selos'}
                            aria-label="Ir para Galeria de Selos"
                            tabIndex={0}
                            className="text-grey-dark text-xs px-4 py-3 uppercase hover:no-underline hover:text-white active:no-underline"
                          >
                            Ver todos
                          </Link>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ) : (
                <>
                  {!loadingCulturaList && (
                    <div className="hidden lg:block border-t-2 border-[#072E4A] mt-3 pt-3">
                      <h3 className="text-white font-bold text-sm mb-3">Galeria de selos</h3>
                      <div className="flex flex-col text-[#628BA7] text-sm">
                        <b className="text-sm">Sua lista de selos está vazia.</b>
                        <p className="text-sm">
                          Você poderá acumular selos que representam conquistas de desempenho no JogaJunto.
                        </p>
                      </div>
                    </div>
                  )}
                </>
              )} */}
            </div>
            {/* {!!groupInfo && (
              <div className="w-full lg:hidden">
                <div className="leading-none flex flex-row items-center justify-between leading-none space-x-1">
                  <div className="text-lg font-bold text-yellow flex-1">{groupInfo.nome}</div>
                  <div className="text-lg p-1 border rounded-lg border-yellow border-opacity-25">{groupInfo.ro}</div>
                  <div className="text-right flex-1">
                    <div className="text-lg leading-none text-yellow">{groupInfo.total}</div>
                    <span>funcis</span>
                  </div>
                </div>
              </div>
            )} */}

            <div className="flex flex-1 flex-col items-center justify-center p-3 lg:border-l-2 lg:border-electric-blue lg:border-solid space-y-3">
              <div
                onClick={() => showModal('help-pontos')}
                className="hidden lg:block cursor-pointer hover:ring-2 rounded-lg ring-white py-1 px-2 w-full"
              >
                <button
                  aria-label={`Pontos Joga Junto: ${
                    pontosCultura.joga_junto ? Intl.NumberFormat('pt-BR').format(Math.ceil(pontosCultura.joga_junto)) : '0'
                  }`}
                  className="text-white leading-none p-0 mb-4  lg:text-md"
                >
                  <b>Pontos Joga Junto</b>
                </button>
                <div className="bg-maastricht-blue text-center text-blue-light rounded-full py-1 px-2 lg:py-1 lg:px-3 text-2xl lg:text-xl lg:text-3xl font-bold">
                  {pontosCultura.joga_junto ? Intl.NumberFormat('pt-BR').format(Math.ceil(pontosCultura.joga_junto)) : '0'}
                </div>
              </div>

              <hr className="block border-t-2 border-[#072E4A] w-full" />

              {userInfo?.tipo_de_acordo === 'HIBRIDO' && (
                <>
                  <div
                    onClick={() => showModal('help-pontos-realizacoes')}
                    className="hidden lg:block cursor-pointer hover:ring-2 rounded-lg ring-white py-1 px-2 w-full"
                  >
                    <button
                      aria-label={`Pontos Realizações Destaque: ${
                        pontosCultura.tasks ? Intl.NumberFormat('pt-BR').format(Math.ceil(pontosCultura.tasks)) : '0'
                      }`}
                      className="text-white leading-none p-0 mb-4  lg:text-md"
                    >
                      <b>Pontos Realizações Destaque</b>
                    </button>
                    <div className="bg-maastricht-blue text-center text-blue-light rounded-full py-1 px-2 lg:py-1 lg:px-3 text-2xl lg:text-xl lg:text-3xl font-bold">
                      {pontosCultura.tasks ? Intl.NumberFormat('pt-BR').format(Math.ceil(pontosCultura.tasks)) : '0'}
                    </div>
                  </div>

                  <hr className="block border-t-2 border-[#072E4A] w-full" />
                </>
              )}

              {/* {!!pontosCultura.time && (
                <p className="font-normal mb-6 text-blue-100 text-[10px]">
                  Atualizado em: {format(utcToZonedTime(pontosCultura.time, 'GMT'), 'dd MMM yyyy')}
                </p>
              )} */}

              <div className="font-bold px-3 w-full">
                <Link
                  to={'/extrato'}
                  aria-label="Ver meu histórico de pontos"
                  className="text-grey-dark text-base lg:text-xs uppercase flex hover:no-underline hover:text-white active:no-underline"
                >
                  <BiPlus color="#C2D2FF" size={14} className="hidden lg:block" />
                  <BiPlus color="#C2D2FF" size={24} className="block lg:hidden" />
                  Ver histórico de pontos
                </Link>
              </div>

              {/* <div className="font-bold px-3 w-full">
                <button
                  aria-label="Ver cartão Retrospectiva 2025"
                  className="text-yellow text-base lg:text-xs uppercase flex hover:no-underline hover:text-white active:no-underline group items-center"
                  onClick={showCardNewYear}
                >
                  <FaEnvelope size={22} className="text-yellow group-hover:text-white mr-2" /> Retrospectiva 2025
                </button>
              </div> */}

              {/* <Tippy
                arrow={false}
                className="hidden lg:block bg-blue-light drop-shadow-lg text-blue-dark"
                allowHTML={true}
                content={getPositionLabel(galeriaReconhecimento)}
              >
                <div className="hidden lg:flex flex-col items-end lg:items-center">
                  <p className="mb-3 text-right lg:text-center leading-none -mt-[15px] uppercase relative">
                    <BiInfoCircle className="mr-1 inline-block lg:hidden" />
                    <b className="lg:text-md block  text-yellow text-center">
                      Galeria do <br />
                      Reconhecimento
                    </b>
                    <BiInfoCircle className="hidden lg:inline-block text-gray-light text-lg absolute -right-6 top-2" />
                  </p>

                  <div className="min-w-[100px] bg-maastricht-blue text-center text-blue-light rounded-full py-1 px-2 lg:py-1 lg:px-3 text-2xl lg:text-xl lg:text-3xl font-bold">
                    {galeriaReconhecimento.position
                      ? `${galeriaReconhecimento.position}º`
                      : '---'}
                  </div>
                </div>
              </Tippy> */}
            </div>

            {/* <div className="flex items-end justify-between lg:hidden w-full">
              <div
                onClick={() => showModal('help-pontos')}
                className="flex items-center justify-end flex-col"
              >
                <p className="text-yellow font-semibold text-xs uppercase leading-none p-0 mb-2 block">
                  Meus Pontos
                </p>
                <div className="bg-maastricht-blue px-4 py-2 text-center text-electric-blue rounded-full font-semibold text-sm">
                  {pontosCultura.geral
                    ? Intl.NumberFormat('pt-BR').format(
                        Math.ceil(pontosCultura.geral)
                      )
                    : '0'}
                </div>
              </div>

              <Tippy
                arrow={false}
                className="bg-blue-light drop-shadow-lg text-blue-dark "
                allowHTML={true}
                content={getPositionLabel(galeriaReconhecimento)}
              >
                <div className="flex items-center justify-end flex-col">
                  <p className="text-yellow font-semibold text-xs uppercase leading-none p-0 mb-2 mr-5 flex items-center justify-center text-center relative">
                    Galeria do <br />
                    Reconhecimento{' '}
                    <BiInfoCircle className="absolute -right-6 top-2 inline-block text-white text-xl" />
                  </p>

                  <div className="bg-maastricht-blue min-w-[60px] px-4 py-2 text-center text-electric-blue rounded-full font-semibold text-sm">
                    {galeriaReconhecimento.position
                      ? `${galeriaReconhecimento.position}º`
                      : '---'}
                  </div>
                </div>
              </Tippy>
            </div> */}
          </div>

          {/* <TutorialChallenges /> */}
          {user.extra.rede && (
            <div
              data-step="2"
              className="border-2 text-lg border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] px-6 lg:px-8 py-8 flex flex-col sm:flex-row space-y-4"
            >
              <img
                src="https://s3.amazonaws.com/funifier/games/635ae06f8cf58e411eeb0b8e/images/66229d868b31775619ea0284_original_imagem.png"
                alt="Tutorial joga junto rede"
                className="w-full sm:w-[45%] pr-8"
                onClick={() => navigate('/?tutorial=open')}
                style={{ cursor: 'pointer' }}
              />
              <div className="flex flex-col items-center">
                <p>
                  Os reconhecimentos enviados para colegas que fazem a diferença na sua rotina de trabalho podem mudar o dia de
                  cada um deles.
                </p>
                <Button
                  className="uppercase py-2 px-5 rounded w-auto mt-8 text-sm"
                  onClick={() => navigate('/?tutorial=open')}
                  aria-label={`Assistir video de tutorial.`}
                >
                  Assistir vídeo
                </Button>
              </div>
            </div>
          )}
          {/* CENTRAL-05.2: some sozinha quando não há aviso não lido. */}
          <NotificationsRow />

          <div
            data-step="2"
            className="relative border-2 border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] px-6 lg:px-8 py-8 flex flex-col space-y-4"
          >
            <h2 className="text-white font-normal text-xl lg:text-2xl leading-none mb-6 lg:mb-2 text-left" tabIndex={0}>
              Reconheça seus colegas
            </h2>

            <div className="lg:flex  lg:space-x-8">
              <div className="lg:w-2/3 mb-8 lg:mb-0">
                {!cycleIsClosed && (
                  <h3 className="text-white font-thin lg:font-normal text-lg mb-2 lg:mb-5 leading-none" tabIndex={0}>
                    Saldo total para enviar reconhecimentos:{' '}
                    <span className="text-yellow">
                      {user?.point_categories?.point_behavior || 0} ponto
                      {!isNaN(user?.point_categories?.point_behavior) && user?.point_categories?.point_behavior !== 1 ? 's' : ''}
                    </span>
                  </h3>
                )}

                {cycleIsOpen && currentCycle ? (
                  <>
                    <p className="block lg:hidden mb-6 text-xs font-thin text-white">
                      Seu saldo atual expira em:{' '}
                      <strong className="font-bold">
                        <Countdown deadline={new Date(currentCycle.date_finish)} />
                      </strong>
                    </p>
                  </>
                ) : null}

                <div
                  data-step="3"
                  className="flex lg:grid lg:grid-cols-3 lg:grid-rows-1 lg:gap-6 flex-col items-center space-y-4 lg:space-y-0 text-center text-yellow font-bold rounded-lg lg:hover:ring-2 lg:hover:ring-white hover:cursor-pointer"
                  onClick={() => showModal('help-moedas-bb')}
                >
                  <button
                    className="box-coins-home relative bg-maastricht-blue rounded-lg p-4 flex flex-col justify-center items-center w-[165px] lg:w-auto bg-none border-none"
                    aria-label="Reconhecimento #UAU equivale a 300 ponto"
                    tabIndex={0}
                  >
                    <div className="flex items-center space-x-2 mb-3">
                      <div className="coin flex-1">
                        <Uau size={20} />
                      </div>
                      <p className="font-normal text-xs leading-tight text-white">#UAU</p>
                    </div>
                    <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                      300 pontos
                    </p>
                  </button>
                  <button
                    className="box-coins-home relative bg-maastricht-blue rounded-lg p-4 flex flex-col justify-center items-center w-[165px] lg:w-auto  bg-none border-none"
                    aria-label="Reconhecimento #MANDOUBEM equivale a 200 pontos"
                    tabIndex={0}
                  >
                    <div className="flex items-center space-x-2 mb-3">
                      <div className="coin mandou flex-1">
                        <MandouBem size={20} />
                      </div>
                      <div className="font-normal text-xs leading-tight text-white">#MANDOUBEM</div>
                    </div>
                    <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                      200 pontos
                    </p>
                  </button>
                  <button
                    className="box-coins-home relative bg-maastricht-blue rounded-lg p-4 flex flex-col justify-center items-center w-[165px] lg:w-auto bg-none border-none"
                    aria-label="Reconhecimento #VALEU equivale a 100 pontos"
                    tabIndex={0}
                  >
                    <div className="flex items-center space-x-2 mb-3">
                      <div className="coin flex-1">
                        <Valeu size={20} />
                      </div>
                      <p className="font-normal text-xs leading-tight text-white">#VALEU</p>
                    </div>
                    <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                      100 pontos
                    </p>
                  </button>
                </div>

                {cycleIsOpen && currentCycle ? (
                  <div>
                    <p className="hidden lg:block mt-3 text-sm font-thin text-white" tabIndex={0}>
                      Seu saldo atual expira em:{' '}
                      <strong className="font-bold">
                        <Countdown deadline={new Date(currentCycle.date_finish)} />
                      </strong>
                    </p>

                    <div className="mt-5">
                      <ProgressBar startDate={currentCycle.date_start} endDate={currentCycle.date_finish} />
                    </div>
                  </div>
                ) : null}

                {/* <p className="text-md font-bold mt-4">Arraiá de Reconhecimento com parceria: UniBB, Livelo e BB Seguros</p> */}
              </div>

              {cycleIsOpen && currentCycle && user?.extra?.recognition !== false ? (
                <div className="flex-1 flex flex-col text-center items-center">
                  {!isNaN(user?.point_categories?.point_behavior) &&
                  user?.point_categories?.point_behavior >= MIN_BALANCE_TO_RECOGNIZE ? (
                    <>
                      <p className="text-sm font-light text-white mb-4" tabIndex={0}>
                        Viu alguém que fez a diferença no seu trabalho? <br className="hidden lg:block" />
                        Deixe-o ficar sabendo disso!
                      </p>
                      {!userInfo?.visualizador && (
                        <>
                          <div className="relative inline-block">
                            <Button
                              className="uppercase py-2 px-5 rounded w-auto"
                              onClick={() => navigate('/reconhecer')}
                              aria-label={`Reconhecer colega. Abre modal para registrar o reconhecimento.`}
                            >
                              Reconhecer colega
                            </Button>
                            {!!hasPartialRecognition && (
                              <Tippy
                                content="Você possui um reconhecimento em preenchimento. Clique no botão para continuar."
                                placement="top"
                              >
                                <div
                                  className="absolute -top-3 -right-3 bg-yellow rounded-full p-1 cursor-pointer"
                                  onClick={() => navigate('/reconhecer')}
                                  style={{
                                    animation: 'partialRecognitionPulse 1.8s ease-in-out infinite',
                                  }}
                                >
                                  <IoIosWarning size={18} className="text-oxford-blue" />
                                </div>
                              </Tippy>
                            )}
                          </div>

                          {/* {!isPointClaimed && currentCycle._id === '68af4e93458e527eaa78853b' && (
                            <Button
                              id="double-points-button"
                              color="clear"
                              className="uppercase py-2 px-5 rounded w-auto mt-5 bg-yellow hover:bg-yellow text-black font-bold animate-bounce"
                              onClick={() => setShowAutoTreeModal(true)}
                              arialabel={`Papai Noel passou anunciando: ${doublePointsMessage} Clique para pegar seus pontos em dobro.`}
                            >
                              <div className="flex items-center justify-center">
                                <BiGift size={24} />
                                Pegar Pontos em Dobro!
                              </div>
                            </Button>
                          )} */}
                        </>
                      )}

                      <div className="font-bold px-3 py-4">
                        <Link
                          to={'/extrato?active=1&sub=SENDED'}
                          className="text-grey-dark text-base lg:text-xs uppercase flex hover:no-underline hover:text-white active:no-underline"
                        >
                          <BiPlus color="#C2D2FF" size={14} className="hidden lg:block" />
                          <BiPlus color="#C2D2FF" size={24} className="block lg:hidden" />
                          ver reconhecimentos
                        </Link>
                      </div>
                    </>
                  ) : (
                    <>
                      <div tabIndex={0}>
                        <p className="text-sm font-light text-white mb-1">Você não possui saldo de pontos para reconhecer.</p>
                        <p className="text-sm font-light text-white">Aguarde até a próxima distribuição.</p>
                      </div>

                      {/* {!isPointClaimed && currentCycle._id === '68af4e93458e527eaa78853b' && (
                        <Button
                          id="double-points-button"
                          color="clear"
                          className="uppercase py-2 px-5 rounded w-auto mt-5 bg-yellow hover:bg-yellow text-black font-bold animate-bounce"
                          onClick={() => setShowAutoTreeModal(true)}
                          arialabel={`Papai Noel passou anunciando: ${doublePointsMessage} Clique para pegar seus pontos em dobro.`}
                        >
                          <div className="flex items-center justify-center">
                            <BiGift size={24} />
                            Pegar Pontos em Dobro!
                          </div>
                        </Button>
                      )} */}

                      <div className="font-bold px-3 text-center py-4">
                        <Link
                          to={'/extrato?active=1&sub=SENDED'}
                          className="text-grey-dark text-center text-base lg:text-xs uppercase flex hover:no-underline hover:text-white active:no-underline"
                        >
                          <BiPlus color="#C2D2FF" size={14} className="hidden lg:block" />
                          <BiPlus color="#C2D2FF" size={24} className="block lg:hidden" />
                          ver reconhecimentos
                        </Link>
                      </div>
                    </>
                  )}
                </div>
              ) : null}

              {cycleIsClosed && (
                <div className="flex-1 flex flex-col text-center items-center">
                  <>
                    <div tabIndex={0}>
                      <p className="text-sm font-light text-white mb-1">Esse ciclo já foi encerrado.</p>
                    </div>

                    <div className="font-bold px-3 text-center py-4">
                      <Link
                        to={'/extrato?active=1&sub=SENDED'}
                        className="text-grey-dark text-center text-base lg:text-xs uppercase flex hover:no-underline hover:text-white active:no-underline"
                      >
                        <BiPlus color="#C2D2FF" size={14} className="hidden lg:block" />
                        <BiPlus color="#C2D2FF" size={24} className="block lg:hidden" />
                        ver reconhecimentos
                      </Link>
                    </div>
                  </>
                </div>
              )}
            </div>
          </div>

          {/* <div
            data-step="4"
            className="border-2 border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] px-6 lg:px-8 py-8 flex flex-row items-center justify-between"
          >
            <div className="w-full">
              <div className="text-white font-normal text-xl lg:text-2xl leading-none mb-2 lg:mb-4 text-left">
                Dimensões do Comportamento
              </div>

              <p className="font-light mb-8 lg:mb-0 text-left block">
                Meus pontos recebidos em cada comportamento e minha posição
                dentro dos{' '}
                <span className="text-yellow">Destaques da Cultura</span>
              </p>

              <div className="grid grid-cols-2 gap-8 lg:flex lg:flex-row items-start lg:items-center justify-between lg:mt-5 lg:px-10">
                <div
                  className={`${
                    !pontosCultura.colaboracao || pontosCultura.colaboracao <= 0
                      ? 'opacity-60'
                      : ''
                  } text-center flex flex-col items-center`}
                >
                  <Tippy
                    arrow={false}
                    className="bg-blue-light drop-shadow-lg text-blue-dark"
                    allowHTML={true}
                    content={getPositionCulturaLabel(
                      destaqueCultura.colaboracao
                    )}
                  >
                    <b className="text-sm lg:text-2xl font-normal lg:font-semibold mb-2 lg:mb-0 relative">
                      {destaqueCultura.colaboracao.posicao
                        ? `${destaqueCultura.colaboracao.posicao}º`
                        : '---'}
                      <BiInfoCircle className="bottom-0 -right-5 absolute text-yellow text-lg inline-block" />
                    </b>
                  </Tippy>
                  <div
                    onClick={() =>
                      showModal('comportamento-help', 'colaboracao')
                    }
                    className="hover:ring-4 cursor-pointer w-14 lg:w-20 h-14 lg:h-20 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                  >
                    <Colaboracao size={'100%'} />
                  </div>
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">
                    COLABORAÇÃO
                  </b>
                  <div className="bg-maastricht-blue text-white p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin">
                      <b className="mr-1">{pontosCultura.colaboracao}</b>pts
                    </span>
                  </div>
                </div>

                <div
                  className={`${
                    !pontosCultura.inovacao || pontosCultura.inovacao <= 0
                      ? 'opacity-60'
                      : ''
                  } text-center flex flex-col items-center`}
                >
                  <Tippy
                    arrow={false}
                    className="bg-blue-light drop-shadow-lg text-blue-dark"
                    allowHTML={true}
                    content={getPositionCulturaLabel(destaqueCultura.inovacao)}
                  >
                    <b className="text-sm lg:text-2xl font-normal lg:font-semibold mb-2 lg:mb-0 relative">
                      {destaqueCultura.inovacao.posicao
                        ? `${destaqueCultura.inovacao.posicao}º`
                        : '---'}
                      <BiInfoCircle className="bottom-0 -right-5 absolute text-yellow text-lg inline-block" />
                    </b>
                  </Tippy>
                  <div
                    onClick={() => showModal('comportamento-help', 'inovacao')}
                    className="hover:ring-4 cursor-pointer w-14 lg:w-20 h-14 lg:h-20 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                  >
                    <Inovacao size={'100%'} />
                  </div>
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">
                    INOVAÇÃO
                  </b>
                  <div className="bg-maastricht-blue text-white p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin">
                      <b className="mr-1">{pontosCultura.inovacao}</b>pts
                    </span>
                  </div>
                </div>

                <div
                  className={`${
                    !pontosCultura.foco || pontosCultura.foco <= 0
                      ? 'opacity-60'
                      : ''
                  } text-center flex flex-col items-center`}
                >
                  <Tippy
                    arrow={false}
                    className="bg-blue-light drop-shadow-lg text-blue-dark"
                    allowHTML={true}
                    content={getPositionCulturaLabel(destaqueCultura.foco)}
                  >
                    <b className="text-sm lg:text-2xl font-normal lg:font-semibold mb-2 lg:mb-0 relative">
                      {destaqueCultura.foco.posicao
                        ? `${destaqueCultura.foco.posicao}º`
                        : '---'}
                      <BiInfoCircle className="bottom-0 -right-5 absolute text-yellow text-lg inline-block" />
                    </b>
                  </Tippy>
                  <div
                    onClick={() => showModal('comportamento-help', 'foco')}
                    className="hover:ring-4 cursor-pointer w-14 lg:w-20 h-14 lg:h-20 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                  >
                    <FocoNoCliente size={'100%'} />
                  </div>
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">
                    FOCO NO CLIENTE
                  </b>
                  <div className="bg-maastricht-blue text-white p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin">
                      <b className="mr-1">{pontosCultura.foco}</b>pts
                    </span>
                  </div>
                </div>

                <div
                  className={`${
                    !pontosCultura.resolutividade ||
                    pontosCultura.resolutividade <= 0
                      ? 'opacity-60'
                      : ''
                  } text-center flex flex-col items-center`}
                >
                  <Tippy
                    arrow={false}
                    className="bg-blue-light drop-shadow-lg text-blue-dark"
                    allowHTML={true}
                    content={getPositionCulturaLabel(
                      destaqueCultura.resolutividade
                    )}
                  >
                    <b className="text-sm lg:text-2xl font-normal lg:font-semibold mb-2 lg:mb-0 relative">
                      {destaqueCultura.resolutividade.posicao
                        ? `${destaqueCultura.resolutividade.posicao}º`
                        : '---'}
                      <BiInfoCircle className="bottom-0 -right-5 absolute text-yellow text-lg inline-block" />
                    </b>
                  </Tippy>
                  <div
                    onClick={() =>
                      showModal('comportamento-help', 'resolutividade')
                    }
                    className="hover:ring-4 cursor-pointer w-14 lg:w-20 h-14 lg:h-20 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                  >
                    <Resolutividade size={'100%'} />
                  </div>
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">
                    PROTAGONISMO
                  </b>
                  <div className="bg-maastricht-blue text-white p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin">
                      <b className="mr-1">{pontosCultura.resolutividade}</b>pts
                    </span>
                  </div>
                </div>

                <div
                  className={`${
                    !pontosCultura.lideranca || pontosCultura.lideranca <= 0
                      ? 'opacity-60'
                      : ''
                  } text-center flex flex-col items-center`}
                >
                  <Tippy
                    arrow={false}
                    className="bg-blue-light drop-shadow-lg text-blue-dark"
                    allowHTML={true}
                    content={getPositionCulturaLabel(destaqueCultura.lideranca)}
                  >
                    <b className="text-sm lg:text-2xl font-normal lg:font-semibold mb-2 lg:mb-0 relative">
                      {destaqueCultura.lideranca.posicao
                        ? `${destaqueCultura.lideranca.posicao}º`
                        : '---'}
                      <BiInfoCircle className="bottom-0 -right-5 absolute text-yellow text-lg inline-block" />
                    </b>
                  </Tippy>
                  <div
                    onClick={() => showModal('comportamento-help', 'lideranca')}
                    className="hover:ring-4 cursor-pointer w-14 lg:w-20 h-14 lg:h-20 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                  >
                    <Lideranca size={'100%'} />
                  </div>
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">
                    LIDERANÇA ENGAJADORA
                  </b>
                  <div className="bg-maastricht-blue text-white p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin">
                      <b className="mr-1">{pontosCultura.lideranca}</b>pts
                    </span>
                  </div>
                </div>
              </div>
              <div className="hidden lg:block text-center text-white pt-4 px-4">
                Pontuação e classificação visível somente a você.
              </div>
            </div>
          </div> */}

          {showTaskCycles ? (
            <>
              <div
                data-step="5"
                className="border-2 border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] px-6 lg:px-8 py-8 flex flex-row items-center justify-between"
              >
                <div className="w-full">
                  <TaskCycles
                    taskManager={[
                      ...(Array.isArray(tasksManager) ? tasksManager : []),
                      ...(Array.isArray(tasksDuplaManager) ? tasksDuplaManager : []),
                    ]}
                    hasPartialTask={hasPartialTask}
                  />
                </div>
              </div>
            </>
          ) : (
            <></>
          )}

          {cycleIsClosed ? (
            <>
              <div
                data-step="5"
                className="border-2 border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] px-6 lg:px-8 py-8 flex flex-row items-center justify-between"
              >
                <div className="w-full">
                  <TaskCyclesClosed
                    taskManager={[
                      ...(Array.isArray(tasksManager) ? tasksManager : []),
                      ...(Array.isArray(tasksDuplaManager) ? tasksDuplaManager : []),
                    ]}
                  />
                </div>
              </div>
            </>
          ) : (
            <></>
          )}

          {!user.extra.rede &&
            !!userInfo?.ecoa &&
            (userInfo?.ecoa === 'TUTOR' || userInfo?.ecoa === 'COORDENADOR' || userInfo?.ecoa === 'INTEGRANTE') && (
              <>
                <div
                  data-step="5"
                  className="border-2 border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] px-6 lg:px-8 py-8 flex flex-row items-center justify-between"
                >
                  <div className="w-full">
                    <TaskCyclesEcoa />
                  </div>
                </div>
              </>
            )}

          {/* A moldura mudou de lugar para dentro de `Company` (HOM-01.5): só ele sabe se algum
              card sobrou no ciclo, e sem card a caixa inteira precisa sumir. */}
          {user?.extra?.actions !== false && <Company />}
        </div>
      </div>
      {/* {showTutorial && closeFeatures && (
        // <UserTutorial
        //   open={openTutorial}
        //   onClose={() => {
        //     setOpenTutorial(false);
        //     setShowTutorial(false);
        //   }}
        // />
      )} */}
      <NewFeatures player={userInfo} send={() => setCloseFeatures(true)} />
      <ComportamentoHelpModal />
      {/* <SeloHelpModal /> */}
      {/* <Decoration /> */}
      {/* <DecorationCarnaval /> */}
      {/* <CarnivalAiModal carnivalData={carnivalData} onImageGenerated={loadCarnivalData} /> */}
      {/* <GameModal /> */}
      <SeloMoedasModal />
      <PontosHelpModal />
      <PontosRealizacoesHelpModal />
      <GroupDetailModal group={groupInfo} />
      <GroupDetailModalExtrato cycleLabel={cycleSelected?.title ? cycleSelected?.title : ''} />

      {/* {userInfo && user?.extra?.tutorial && user?.extra?.accept && <OvoPascoaInterativo />} */}

      {location.pathname === '/' && user?.extra?.actions !== false && <Notification />}

      {showQuiz && <Quiz onClose={() => setShowQuiz(false)} setQuizAnswered={() => {}} />}

      <TaskOtherIndication onSettled={() => setTaskOtherIndicationSettled(true)} />

      {/* Campanha de Natal */}
      {/* <ChristmasFallingParticles particleCount={30} /> */}
      {/* <ChristmasGiftModal /> */}

      <NewYearEnvelopeModal onClose={() => setShowNewYearModal(false)} />

      {/* {!showNewYearModal &&
        closeFeatures &&
        !isPointClaimed &&
        currentCycle &&
        currentCycle._id === '68af4e93458e527eaa78853b' &&
        currentCycle.status === 'open' && (
          <ChristmasSantaSlide message={doublePointsMessage} onAnimationComplete={() => setShowClaimButton(true)} />
        )}
      {showAutoTreeModal && currentCycle && currentCycle._id === '68af4e93458e527eaa78853b' && currentCycle.status === 'open' && (
        <ChristmasTreeModal showOnMount={true} autoOpenPresent={true} />
      )} */}

      {/* <UserNeedingApprovalModal users={usersNeedingApproval} /> */}
      {/* <GroupDetailModal totalGroup={groupInfo?.total} /> */}

      {/* {closeFeatures && (
        <QuizV2 onClose={() => refreshUser()} setQuizAnswered={() => {}} onOpenItem={() => setShowSantaSlide(true)} />
      )} */}

      {closeFeatures && hasPartialTask && (
        <PartialTask
          onClose={() => {
            setShowFeedbackCampaignModal(true);
            setPartialTaskClosed(true);
          }}
        />
      )}

      {closeFeatures && hasPartialRecognition && !hasPartialTask && (
        <PartialRecognition onClose={() => setPartialRecognitionClosed(true)} />
      )}

      {/* {closeFeatures && !showNewYearModal && isPointClaimed && (hasPartialTask === false || showFeedbackCampaignModal) && (
        <FeedbackCampaignModal onClose={() => {}} />
      )} */}

      {closeFeatures && hasTeamsRecognition && !teamsRecognitionSkipped && (
        <TeamsEvaluationModal
          onClose={() => setHasTeamsRecognition(false)}
          onSkip={() => setTeamsRecognitionSkipped(true)}
        />
      )}

      {/* A ULTIMA modal automatica (R10): so abre com o Dashboard quieto — ver ./modal-queue.ts. */}
      <CatalogRestockModal
        enabled={canAccessExperienceCatalog(userInfo)}
        playerId={userInfo?.chave}
        signals={{
          acceptSettled: closeFeatures,
          partialTaskSettled: hasPartialTask === false || partialTaskClosed,
          partialRecognitionSettled:
            hasPartialRecognition === false || hasPartialTask === true || partialRecognitionClosed,
          teamsRecognitionSettled: hasTeamsRecognition === false || teamsRecognitionSkipped,
          taskOtherIndicationSettled,
          quizClosed: !showQuiz,
          contextSlotFree: openModal === undefined,
        }}
      />
    </>
  );
}
